// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-container[data-v-4c1475cc] {\n  margin-bottom: 20px;\n}\n.btn-add-feature[data-v-4c1475cc] {\n  float: right;\n}\n", ""]);
// Exports
module.exports = exports;
